export const categoryData = {
  wanghong: {
    title: "网红黑料",
    description: "追踪全网网红不为人知的另一面，独家爆料网红圈内幕",
    articles: [
      {
        id: 1,
        title: "某千万粉丝女主播被曝私下与榜一大哥约会，聊天记录曝光",
        excerpt: "近日有知情人士爆料，某平台拥有千万粉丝的女主播私下频繁与多位榜一大哥约会。",
        image: "https://readdy.ai/api/search-image?query=Dark%20studio%20with%20streaming%20equipment%20and%20empty%20chair%2C%20dramatic%20side%20lighting%2C%20mysterious%20investigative%20atmosphere%2C%20red%20accent%20glow%2C%20cinematic%20noir%20style%2C%20deep%20shadows%2C%20professional%20photography&width=800&height=500&seq=cat-wanghong-01&orientation=landscape",
        date: "2026-07-06",
        views: 1289300,
        slug: "female-streamer-scandal-exposed"
      },
      {
        id: 3,
        title: "网红情侣分手内幕：财产纠纷升级，女方晒出转账记录",
        excerpt: "一对拥有数百万粉丝的网红情侣突然宣布分手，女方晒出大量转账记录。",
        image: "https://readdy.ai/api/search-image?query=Broken%20phone%20screen%20showing%20transaction%20records%20on%20dark%20surface%2C%20dramatic%20lighting%2C%20emotional%20breakup%20symbolism%2C%20dark%20atmospheric%20background%2C%20cinematic%20composition%2C%20moody%20photography&width=800&height=500&seq=cat-wanghong-02&orientation=landscape",
        date: "2026-07-04",
        views: 1892300,
        slug: "influencer-couple-breakup-drama"
      },
      {
        id: 5,
        title: "电竞圈大地震：知名职业选手涉嫌假赛被联盟调查",
        excerpt: "多名职业选手被曝参与外围赌博操控比赛结果。",
        image: "https://readdy.ai/api/search-image?query=Dark%20esports%20arena%20empty%20stage%20with%20spotlight%2C%20gaming%20chairs%20in%20shadow%2C%20investigative%20drama%20atmosphere%2C%20cinematic%20lighting%2C%20blue%20and%20red%20accent%20glow&width=800&height=500&seq=cat-wanghong-03&orientation=landscape",
        date: "2026-07-02",
        views: 978500,
        slug: "esports-match-fixing-scandal"
      },
      {
        id: 8,
        title: "知名带货主播被指虚假宣传，消费者集体维权",
        excerpt: "某头部带货主播因涉嫌虚假宣传被消费者集体投诉。",
        image: "https://readdy.ai/api/search-image?query=Empty%20livestream%20studio%20with%20ring%20light%20and%20products%2C%20dramatic%20backlighting%2C%20investigative%20journalism%20style%2C%20dark%20moody%20atmosphere&width=800&height=500&seq=cat-wanghong-04&orientation=landscape",
        date: "2026-06-29",
        views: 1890200,
        slug: "livestream-false-advertising"
      }
    ]
  },
  mingxing: {
    title: "明星八卦",
    description: "娱乐圈最新最热的明星八卦资讯，影视歌三栖明星动态一手掌握",
    articles: [
      {
        id: 2,
        title: "知名男星深夜密会神秘女子，疑似婚内出轨证据确凿",
        excerpt: "有媒体拍到某一线男星深夜与一名神秘女子在某高档酒店共处近六小时。",
        image: "https://readdy.ai/api/search-image?query=Dark%20hotel%20corridor%20with%20two%20blurred%20figures%2C%20dramatic%20hallway%20lighting%2C%20cinematic%20noir%20aesthetic%2C%20mysterious%20encounter%20scene%2C%20deep%20shadows%2C%20moody%20atmosphere&width=800&height=500&seq=cat-mingxing-01&orientation=landscape",
        date: "2026-07-05",
        views: 2156700,
        slug: "male-celebrity-cheating-scandal"
      },
      {
        id: 4,
        title: "某综艺节目录制现场突发冲突，两位导师当场翻脸",
        excerpt: "两位常驻导师因选手评分问题发生激烈争执。",
        image: "https://readdy.ai/api/search-image?query=Dark%20tv%20studio%20with%20spotlights%20and%20empty%20judges%20chairs%2C%20dramatic%20stage%20lighting%2C%20conflict%20tension%20atmosphere%2C%20cinematic%20composition&width=800&height=500&seq=cat-mingxing-02&orientation=landscape",
        date: "2026-07-03",
        views: 3451200,
        slug: "variety-show-fight-incident"
      },
      {
        id: 6,
        title: "某女星整容前后对比照曝光，网友直呼认不出",
        excerpt: "一组某知名女星的素颜街拍照片在网络上疯传。",
        image: "https://readdy.ai/api/search-image?query=Split%20face%20concept%20half%20light%20half%20shadow%2C%20before%20after%20symbolism%2C%20dark%20elegant%20background%2C%20editorial%20photography%20style&width=800&height=500&seq=cat-mingxing-03&orientation=landscape",
        date: "2026-07-01",
        views: 1567800,
        slug: "actress-plastic-surgery-exposed"
      },
      {
        id: 10,
        title: "某剧组拍摄现场发生意外，演员受伤送医",
        excerpt: "某大型古装剧拍摄现场突发意外事故，威亚设备出现故障。",
        image: "https://readdy.ai/api/search-image?query=Empty%20film%20set%20with%20rigging%20equipment%20in%20darkness%2C%20spotlight%20on%20empty%20scene%2C%20dramatic%20backstage%20atmosphere&width=800&height=500&seq=cat-mingxing-04&orientation=landscape",
        date: "2026-06-27",
        views: 1678900,
        slug: "film-set-accident-injury"
      }
    ]
  },
  shehui: {
    title: "社会奇闻",
    description: "大千世界无奇不有，每日精选社会热点奇闻异事",
    articles: [
      {
        id: 7,
        title: "某城市深夜发生离奇事件，监控拍下全过程",
        excerpt: "一段深夜监控视频在社交媒体引发广泛关注。",
        image: "https://readdy.ai/api/search-image?query=Dark%20foggy%20street%20at%20night%20with%20CCTV%20camera%2C%20eerie%20streetlight%20glow%2C%20mysterious%20urban%20atmosphere%2C%20cinematic%20horror%20aesthetic&width=800&height=500&seq=cat-shehui-01&orientation=landscape",
        date: "2026-06-30",
        views: 2345600,
        slug: "midnight-mystery-cctv-footage"
      },
      {
        id: 9,
        title: "某富二代深夜飙车被拘，车内搜出大量违禁物品",
        excerpt: "警方深夜在市中心拦截一辆超速行驶的豪车。",
        image: "https://readdy.ai/api/search-image?query=Luxury%20car%20on%20dark%20wet%20street%20with%20police%20lights%2C%20blue%20red%20flashing%2C%20night%20crime%20scene%2C%20dramatic%20urban%20atmosphere&width=800&height=500&seq=cat-shehui-02&orientation=landscape",
        date: "2026-06-28",
        views: 4123000,
        slug: "rich-kid-street-racing-arrest"
      }
    ]
  }
};

export const articleDetail = {
  id: 1,
  title: "某千万粉丝女主播被曝私下与榜一大哥约会，聊天记录曝光",
  author: "911爆料编辑部",
  date: "2026-07-06",
  source: "911爆料网独家",
  category: "网红黑料",
  views: 1289300,
  image: "https://readdy.ai/api/search-image?query=Dark%20mysterious%20smartphone%20screen%20showing%20chat%20messages%20in%20Chinese%2C%20dramatic%20side%20lighting%20from%20window%2C%20deep%20shadows%2C%20noir%20cinematic%20style%2C%20investigative%20journalism%20atmosphere%2C%20red%20notification%20glow%2C%20moody%20and%20suspenseful%20tone%2C%20dark%20background&width=1600&height=700&seq=article-detail-hero-01&orientation=landscape",
  content: `<p>近日，一则关于某平台千万粉丝级别女主播的爆料在网络上引发轩然大波。据知情人士透露，该女主播在直播事业如日中天之际，被拍到与多位榜一大哥私下约会的画面，更有大量聊天记录和转账截图流出。</p>
  <p>根据曝光的聊天记录显示，该女主播与多位高额打赏者保持着超出正常粉丝互动范围的关系。聊天内容涉及私下见面安排、贵重礼物交换以及大额转账记录。其中一位榜一大哥的累计打赏金额已超过三百万人民币。</p>
  <p>事件曝光后，该女主播的社交账号评论区瞬间沦陷。大量粉丝纷纷表示失望和愤怒，认为自己在不知情的情况下被欺骗了感情和金钱。有粉丝计算，仅在上月的生日专场直播中，该主播就收到了超过五十万的打赏。</p>
  <p>与此同时，事件的另一个焦点集中在平台责任上。多位法律人士指出，如果平台在明知主播存在诱导消费行为的情况下不予制止，可能需要承担连带责任。目前，该直播平台尚未对此事做出正式回应。</p>
  <p>更令人震惊的是，爆料者还提供了一份疑似该女主播与签约公会的内部协议。协议显示，公会曾专门为其制定了一套榜一维护方案，系统性地指导主播如何与高消费用户建立并维持亲密关系，以最大化打赏收入。</p>
  <p>截至目前，该女主播已有超过48小时未在任何社交平台更新动态。她的直播间也处于关闭状态，显示主播正在休息。而在各大社交平台上，关于此事的讨论热度持续攀升，相关话题阅读量已突破五亿。</p>
  <p>业内人士分析认为，此次事件可能成为直播行业整顿的导火索。近年来，直播打赏乱象频出，从诱导未成年人消费到主播与粉丝间的不当关系，监管层面一直高度关注。据悉，有关部门或将借此事件推动更严格的直播行业规范出台。</p>`,
  testimonials: [
    {
      quote: "我只是一个普通的打工族，每个月省吃俭用给她刷礼物，累计花了十几万。现在看到这些聊天记录，心都碎了。原来我不过是她维护方案中的一个编号。",
      name: "匿名粉丝A",
      verified: true
    },
    {
      quote: "作为行业从业者，这种现象其实并不罕见。只不过这次是被曝光出来了。很多主播都有类似的维护套路，这是直播行业的一大毒瘤。",
      name: "业内人士老K",
      verified: true
    }
  ],
  faq: [
    { question: "该女主播目前是否仍在直播？", answer: "截至发稿时，该女主播的直播间已关闭超过48小时，所有社交平台账号均未更新。据其公会内部人士透露，正在商讨应对方案。" },
    { question: "涉事金额有多大？", answer: "根据已曝光的聊天记录和转账截图，仅从三位榜一大哥处获得的打赏和私下转账，累计金额保守估计超过五百万元人民币。" },
    { question: "平台方是否会承担责任？", answer: "多位法律专家表示，如果平台在明知主播存在诱导消费行为的情况下未采取制止措施，可能面临监管处罚和民事连带责任。目前相关监管部门已关注此事。" },
    { question: "如何避免类似事件发生？", answer: "专家建议消费者保持理性消费观念，不要被主播的虚假人设所迷惑。同时呼吁平台加强监管，建立更完善的举报和审核机制，从源头上遏制此类行为。" }
  ],
  relatedArticles: [
    { id: 3, title: "网红情侣分手内幕：财产纠纷升级，女方晒出转账记录", slug: "influencer-couple-breakup-drama" },
    { id: 8, title: "知名带货主播被指虚假宣传，消费者集体维权", slug: "livestream-false-advertising" },
    { id: 5, title: "电竞圈大地震：知名职业选手涉嫌假赛被联盟调查", slug: "esports-match-fixing-scandal" }
  ]
};

export const aboutData = {
  brandStory: "911爆料网成立于2023年，是国内领先的娱乐八卦资讯平台。我们致力于为广大网友提供最新、最全、最真实的网红黑料、明星八卦及社会奇闻资讯。自创立以来，911爆料网始终坚持真实第一、快速更新的原则，建立了一支专业的采编团队，遍布全国主要城市的线人网络，确保每一条爆料都有据可查、每一个瓜都新鲜热辣。我们的使命是成为中文互联网最值得信赖的爆料资讯平台，让每一位网友都能在这里第一时间吃到最新鲜的瓜。",
  mission: "我们相信信息的力量。在这个信息爆炸的时代，辨别真伪比获取信息更加重要。911爆料网坚持事实核查，每一条爆料都经过多方交叉验证，确保信息的真实性和可靠性。我们不仅是一个资讯平台，更是一个为公众利益服务的监督力量。",
  advantages: [
    {
      icon: "ri-global-line",
      title: "全网覆盖",
      description: "覆盖全网主流社交平台及短视频平台，线人网络遍布全国30+城市，7×24小时不间断追踪最新爆料动态。"
    },
    {
      icon: "ri-shield-check-line",
      title: "权威认证",
      description: "每一条爆料均经过专业编辑团队的多方交叉验证，确保信息真实可靠。坚持事实核查，拒绝虚假信息和谣言传播。"
    },
    {
      icon: "ri-flashlight-line",
      title: "极速更新",
      description: "事件发生后15分钟内快速响应，重大爆料5分钟内推送。技术驱动的信息采集系统确保用户第一时间掌握最新动态。"
    }
  ],
  contact: {
    email: "hello@chiguabang.cn",
    phone: "400-911-8888",
    address: "北京市朝阳区望京SOHO T3-A座 2801室",
    wechat: "911baoliao666",
    weibo: "@911爆料网官方"
  }
};